import type React from "react";

import { PluginPlaceholder } from "metabase/plugins/components/PluginPlaceholder";
import type { IconProps } from "metabase/ui";
import type { ColorName } from "metabase/ui/colors/types";
import type Question from "metabase-lib/v1/Question";
import type {
  BaseUser,
  Card,
  Dashboard,
  IconName,
  MetabotInfo,
  ModerationReview,
} from "metabase-types/api";

import { definePluginSlot } from "../slot";

export type RevisionOrModerationEvent = {
  title: string;
  timestamp: string;
  icon: IconName | { name: IconName; color: ColorName } | Record<string, never>;
  description?: string;
  revision?: any;
};

export type EntityModerationIconProps = {
  moderationReviews?: ModerationReview[];
};

export type ModerationStatusIconProps = Omit<IconProps, "name"> & {
  status?: string | null | false;
  filled?: boolean;
};

const getDefaultPluginModeration = () => ({
  isEnabled: () => false,
  EntityModerationIcon: PluginPlaceholder<EntityModerationIconProps>,
  ModerationReviewTextForQuestion: PluginPlaceholder<{ question: Question }>,
  ModerationReviewTextForDashboard: PluginPlaceholder<{ dashboard: Dashboard }>,
  ModerationStatusIcon: PluginPlaceholder<ModerationStatusIconProps>,
  getQuestionIcon: PluginPlaceholder,
  getStatusIcon: (_moderated_status?: string): string | IconProps | undefined =>
    undefined,
  getModerationTimelineEvents: (_reviews: any, _currentUser: BaseUser | null) =>
    // Unjustified type cast. FIXME
    [] as RevisionOrModerationEvent[],
  useDashboardMenuItems: (
    _model?: Dashboard,
    _reload?: () => void,
  ): React.JSX.Element[] => [],
  useQuestionMenuItems: (
    _model?: Question,
    _reload?: () => void,
  ): React.JSX.Element[] => [],
  useCardMenuItems: (
    _model?: Card,
    _reload?: () => void,
  ): React.JSX.Element[] => [],
  MetabotVerifiedContentConfigurationPane:
    // Unjustified type cast. FIXME
    PluginPlaceholder as React.ComponentType<{ metabot: MetabotInfo }>,
});

export const PLUGIN_MODERATION = definePluginSlot(getDefaultPluginModeration);
